import setModalVideo from "../../../frontend/js/video-modal";

class CampaignHeroVideoPlayer {
    constructor() {
        const playButtons = [...document.querySelectorAll('.content-block__play')];

        playButtons.map(item => {
            const headRoomElement = document.querySelector('.headroom');
            item.addEventListener('pointerup', function (event) {
                
                if (event.which !== 1)
                    return;

                headRoomElement.style.zIndex = "3";
                const videoUrl = `https://www.youtube.com/embed/${item.dataset.videoUrl}?autoplay=1&mute=1`
                const videoHost = 'youtube';
                setModalVideo({ videoHost, videoUrl })
            });
        })
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new CampaignHeroVideoPlayer();
});